export default {"src":"/_next/static/media/dollarRaw.8d873ea2.svg","height":20,"width":13};